import { useState } from "react";
import { message } from "antd";
import { useParams } from "react-router-dom";
import { workwiseServices } from "../../../Api/api";
import { MindMapContext } from "../../../Context/contex";
import useMindMapService from "../../../hooks/useMindMapService";

const WORKWISE_PUBLIC_PRIVACY_ID = 1;
const SUCCESS_STATUS = 200;

/**
 * Makes the map public (anyone with the link) or removes that external access.
 * Each closes the dialog once the change is made; on failure it stays open.
 */
export const usePublicAccess = (onClose) => {
  const { documentId } = useParams();
  const { documentInfo, setDocumentInfo, setIsExternalAllow } = MindMapContext();
  const mindMapService = useMindMapService();
  const [isPublishing, setIsPublishing] = useState(false);
  const [isRemoving, setIsRemoving] = useState(false);

  const makePublic = async () => {
    setIsPublishing(true);
    try {
      await workwiseServices.shareDocumentToAnyone({
        attachmentId: documentId,
        name: documentInfo?.name,
        privacyId: WORKWISE_PUBLIC_PRIVACY_ID,
      });
      message.success("Document is shared as Public");
      onClose();
      const response = await workwiseServices.getDocumentById(documentId);
      if (response?.status === SUCCESS_STATUS && response.data?.data?.rightType !== 0) {
        setDocumentInfo(response.data.data);
      }
      await mindMapService.updateDocumentPrivacy({ documentId, isExternal: true, name: documentInfo?.name });
      setIsExternalAllow(true);
    } catch (error) {
      console.error("Error sharing document:", error);
      message.error("Failed to share document. Please try again.");
      setIsPublishing(false);
    }
  };

  const removePublicAccess = async () => {
    setIsRemoving(true);
    try {
      await mindMapService.updateDocumentPrivacy({ documentId, isExternal: false, name: documentInfo?.name });
      setIsExternalAllow(false);
      message.success("External access removed successfully!");
      onClose();
    } catch (error) {
      console.error("Error removing document access:", error);
      message.error(error.response?.data?.message || "Failed to remove access.");
      setIsRemoving(false);
    }
  };

  return { makePublic, removePublicAccess, isPublishing, isRemoving };
};
